export const STATUS_COLORS = {
  PENDING:          { bg: '#FFF3E0', fg: '#E65100', label: 'Pendiente' },
  IN_PROGRESS:      { bg: '#E3F2FD', fg: '#0066CC', label: 'En proceso' },
  READY_FOR_PICKUP: { bg: '#E8F5E9', fg: '#00A86B', label: 'Listo para retiro' },
  COMPLETED:        { bg: '#E0E0E0', fg: '#424242', label: 'Completado' },
  CANCELLED:        { bg: '#FFEBEE', fg: '#C62828', label: 'Cancelado' },
} as const;

export function statusStyle(status: string): { bg: string; fg: string; label: string } {
  return STATUS_COLORS[status as keyof typeof STATUS_COLORS]
    ?? { bg: '#ECEFF1', fg: '#455A64', label: status };
}
